module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-428.1754ad1.woff2";